/**
 * This composition function provides utility functions for working with careConcept data in the context of 
 * the csearch UI and Cpn.  
 */
export default() => {

    /**
     * Converts a care concept object into an Id String suitable to be sent to the search service.
     * ie.
     *   {
     *     type: 'service',
     *     id: '462',
     *     name: 'DBT Group - Adult',
     *     practiceType: 'medical',
     *     serviceType: 'location
     *   },
     *
     *  To:
     *  lsv462
     */
    const careConceptToCpnId = (careConcept) => {
        const { type, id, serviceType, score } = careConcept

        if ( type == 'medicalequipment' ) {
            return score ? `dme${id}-${score}` : `dme${id}`
        }
        const prefix = serviceType == 'location' ? 'l' : 'p'
        const suffix = type == 'specialty' ? 'sp' : 'sv'
        //Return the concept in the form that CPN expects it and add on the lingo2 score.
        return score ? `${prefix}${suffix}${id}-${score}` : `${prefix}${suffix}${id}`

    }

    /**
     * Convert a list of care concept objects into a list of ids suitable for sending to the CPN search service.
     */
    const careConceptsToCpnIds = (careConcepts) => {
        return careConcepts.map((concept) => careConceptToCpnId(concept))
    }

    /**
     * Transform raw careConcepts from the database into concepts suitable for filters in the UI.
     */
    const transFormCareConceptsForFilters = (concepts) => {
        const transformed = concepts.map( c => {
            return {
                _id: c._id,
                id: careConceptToCpnId(c),
                name: c.name,
                type: c.type,
                serviceType: c.serviceType
            }
        })
        return transformed
    }
  

    return { careConceptToCpnId, careConceptsToCpnIds, transFormCareConceptsForFilters }

}